module.exports = __webpack_public_path__ + "img/attendee-settings-show-legend.0bbfc4e9.png";